(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('notification-settings', {
            parent: 'entity',
            params:{screen: 'BankNotificationSettings'},
            url: '/notification-settings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.notificationSettings.settings" | translate }}',
                parent: 'home'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/notification-settings/notification-settings.html',
                    controller: 'NotificationSettingsController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'smd',
                    resolve: {
                        entity: function(){
                        	
                        }
                    }
                }).result.then(function() {
                    $state.go('home', null, {reload:true});
                }, function() {
                    $state.go('home', null, {reload:true});
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('notificationSettings');
                    $translatePartialLoader.addPart('user-management');
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
           .state('change-notification-settings', {
                    parent: 'notification-settings',
                    url: '/change-notification-settings/{headerLabel}/{labelName}/{settingsName}/{settingsValue}/{settingsType}/{screenName}',
                    data: {
                        authorities: ['ROLE_USER'],
                        pageTitle: 'global.title'
                    },
                    ncyBreadcrumb: {
                        label: '{{ "global.menu.faq.gatewayDesk" | translate }}',
                        parent: 'user-profile'
                    },
                    onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                        $uibModal.open({
                            templateUrl: 'app/entities/notification-settings/change-notification-setting.html',
                            controller: 'ChangeNotificationSettingsController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            size: 'sm',
                            resolve: {
                                entity: function(){
                                    
                                }
                            }
                        }).result.then(function() {
                            $state.go('^', {}, { reload: false });
                        }, function() {
                            $state.go('^');
                        });
                    }],
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('notificationSettings');
                            $translatePartialLoader.addPart('userProfile');
                            $translatePartialLoader.addPart('user-management');
                            $translatePartialLoader.addPart('error');
                            $translatePartialLoader.addPart('global');
                            return $translate.refresh();
                        }]
                       
                    }
                })
                
                 .state('notification-settings-auditlog', {
                    parent: 'audit-log',
                    url: '/notification-settings-auditlog',
                    data: {
                        authorities: ['ROLE_USER'],
                        pageTitle: 'global.title'
                    },
                    ncyBreadcrumb: {
                        label: '{{ "global.menu.faq.gatewayDesk" | translate }}',
                        parent: 'user-profile'
                    },
                    onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                        $uibModal.open({
                            templateUrl: 'app/entities/notification-settings/change-notification-setting.html',
                            controller: 'ChangeNotificationSettingsController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            size: 'sm',
                            resolve: {
                                entity: function(){
                                    
                                }
                            }
                        }).result.then(function() {
                            $state.go('^', {}, { reload: false });
                        }, function() {
                            $state.go('^');
                        });
                    }],
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('notificationSettings');
                            $translatePartialLoader.addPart('userProfile');
                            $translatePartialLoader.addPart('user-management');
                            $translatePartialLoader.addPart('error');
                            $translatePartialLoader.addPart('global');
                            return $translate.refresh();
                        }]
                       
                    }
                })
                .state('notification-settings-historyreport', {
                    parent: 'history-report',
                    url: '/notification-settings-historyreport',
                    data: {
                        authorities: ['ROLE_USER'],
                        pageTitle: 'global.title'
                    },
                    ncyBreadcrumb: {
                        label: '{{ "global.menu.faq.gatewayDesk" | translate }}',
                        parent: 'user-profile'
                    },
                    onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                        $uibModal.open({
                            templateUrl: 'app/entities/notification-settings/change-notification-setting.html',
                            controller: 'ChangeNotificationSettingsController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            size: 'sm',
                            resolve: {
                                entity: function(){
                                    
                                }
                            }
                        }).result.then(function() {
                            $state.go('^', {}, { reload: false });
                        }, function() {
                            $state.go('^');
                        });
                    }],
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('notificationSettings');
                            $translatePartialLoader.addPart('userProfile');
                            $translatePartialLoader.addPart('user-management');
                            $translatePartialLoader.addPart('error');
                            $translatePartialLoader.addPart('global');
                            return $translate.refresh();
                        }]
                       
                    }
                })
                
                .state('notification-settings-todolist', {
                    parent: 'dashboard',
                    url: '/notification-settings-view',
                    data: {
                        authorities: ['ROLE_USER'],
                        pageTitle: 'global.title'
                    },
                    onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                        $uibModal.open({
                            templateUrl: 'app/entities/notification-settings/change-notification-setting.html',
                            controller: 'ChangeNotificationSettingsController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            size: 'sm',
                            resolve: {
                                entity: function () {                        	
                                    return {
                                            
                                    };
                                }
                            }
                        }).result.then(function() {
                            $state.go('^', null, { reload: true });
                        }, function() {
                            $state.go('^');
                        });
                    }],
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('notificationSettings');
                            $translatePartialLoader.addPart('error');
                            $translatePartialLoader.addPart('global');
                            return $translate.refresh();
                        }]
                       
                    }
                })
                .state('notification-todoList-resubmit', {
                    parent: 'dashboard',
                    url: '/notification-resubmit',
                    data: {
                        authorities: ['ROLE_USER']
                    },
                    onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                        $uibModal.open({
                            templateUrl: 'app/entities/notification-settings/change-notification-setting.html',
                            controller: 'ChangeNotificationSettingsController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            size: 'sm',
                            resolve: {
                              entity: function () {                        	
        
                                }
                            }
                        }).result.then(function() {
                            $state.go('^', null, { reload: true });
                        }, function() {
                            $state.go('^');
                        });
                    }],
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('notificationSettings');
                             $translatePartialLoader.addPart('error');
                            $translatePartialLoader.addPart('global');
                            return $translate.refresh();
                        }]
                       
                    }
                })
         };
    })();
